<section>
  <!--  shopping car items and save for latter-->
  <div class="grid grid-cols-2 border-b border-t border-b-gris4 border-t-gris4 sm:mx-[120px]">
    <button
      class="items-center pb-[16px] pt-[17px] text-center text-base font-bold text-cafe sm:pb-[10px] sm:pt-[14px]"
      (click)="ToogleCartItemsSelected(true)">
      {{'buttons.cart' | transloco}} ({{ cardItemsCount() }})
    </button>
<!--    (click)="ToogleCartItemsSelected(false)"-->
<!--    <button-->
<!--      class="items-center pb-[16px] pt-[17px] text-center text-base font-bold text-cafe sm:pb-[10px] sm:pt-[14px]"-->
<!--      >-->
<!--      {{'buttons.saved' | transloco}} ({{ saveForLatterItems() }})-->
<!--    </button>-->
    <div></div>

    <div
      [ngClass]="{
        'border-b-[3px] border-b-rojo sm:border-b-[7px]': cartItemsSelected(),
        'border-b-transparent': !cartItemsSelected(),
      }"></div>
    <div
      [ngClass]="{
        'border-b-[3px] border-b-rojo sm:border-b-[7px]': !cartItemsSelected(),
        'border-b-transparent': cartItemsSelected(),
      }"></div>
  </div>

    <section class="pb-[55px] sm:mx-[120px]">
      @if(productDeletedFromCart()){
        <div class="flex w-full justify-center my-[18px]"> <ln-shopping-cart-product-deleted></ln-shopping-cart-product-deleted> </div>
      }
      @if (cardItemsCount()) {
      @if (cartItemsSelected()) {
        <!--  productos -->
        <div class="mt-[30px] grid grid-cols-1 sm:mt-[39px] md:grid-cols-2">
          <div>
            <div class="sm:[ml-0px] ml-[35px] text-xl sm:text-2xl font-bold text-cafe">
              {{'labels.yourCart' | transloco}} <span class="text-xl font-normal sm:text-2xl"> ({{ cardItemsCount() }} {{ cardItemsCount() > 1 ? ('labels.products' | transloco) : ('labels.product' | transloco) }}) </span>
            </div>
            <div class="sm:[ml-0px] mb-[30px] ml-[35px] mt-[25px] text-lg font-bold text-rojo sm:text-xl">
              {{'labels.selectedProducts' | transloco}}
            </div>
            <div class="sm:[ml-0px] ml-[22px] flex flex-col gap-y-[20px]">
              @for (items of cardItems(); track items) {
                <ln-product-item-card class="flex justify-start" [product]="items"></ln-product-item-card>
              }
            </div>
          </div>

          <div class="sm:[ml-0px] ml-[20px] mt-[20px] w-full sm:mt-[5px]">
            <ln-purchase-summary
              class="flex h-fit w-full justify-start md:justify-center"
              [subTotal]="shoppingCartResumeSubtotal()" [singleProductAlert]="existSinglePieceProduct()"></ln-purchase-summary>
          </div>
        </div>
      } @else {
        <div class="sm:[ml-0px] ml-[35px] mt-[30px] sm:mt-[39px]">
          <div class="my-4 pb-[270px] text-lg font-bold text-[#B79086] sm:text-xl">{{'labels.savedProducts' | transloco}}</div>
          <!--    <ln-product-save-for-latter-card></ln-product-save-for-latter-card>-->
        </div>
      }
      } @else {
        <div class="mt-[45px] sm:mt-[106px] flex flex-col place-items-center">
          <ln-empty-shopping-cart-card></ln-empty-shopping-cart-card>
          <ln-primary-button [label]="'labels.addProducts'| transloco" [class]= "'flex w-[345px] h-[48px] mt-[30px] bg-[#577778] text-base font-semibold text-white/90 items-center rounded-md justify-center '" (OnClick)="goHome()"></ln-primary-button>
        </div>
      }
    </section>
</section>
